// extracted by mini-css-extract-plugin
export default {"modalContent":"a9GylIe1","modalFooter":"NVbEvWm7","closeButton":"l2YtWgLw","feedbackDetails":"vqKyPUX9"};